// EP-59 — labels for the two STI subclasses of Lease (Thai)
export default {
  entity: {
    rental: 'สัญญาเช่า',
    ownership: 'เจ้าของร่วม',
  },
  list: {
    title: {
      rental: 'สัญญาเช่า',
      ownership: 'เจ้าของร่วม',
    },
  },
  detail: {
    header: {
      rental: 'สัญญาเช่า #{{code}}',
      ownership: 'บันทึกเจ้าของร่วม #{{code}}',
    },
  },
  customer_role: {
    tenant: 'ผู้เช่า',
    shared_owner: 'เจ้าของร่วม',
  },
  date_label: {
    start: {
      rental: 'วันที่เข้าอยู่',
      ownership: 'วันที่โอนกรรมสิทธิ์',
    },
    end: {
      rental: 'วันที่ย้ายออก',
      ownership: 'วันที่ขาย/โอนกรรมสิทธิ์',
    },
  },
  actions: {
    mark_transferred: 'บันทึกการโอนกรรมสิทธิ์',
  },
  attachments: {
    rental: 'ไฟล์แนบสัญญาเช่า',
    ownership: 'เอกสารกรรมสิทธิ์ (สัญญาซื้อขาย, โฉนดห้องชุด)',
  },
}
